/**
 * Used to categorise rate limit configurations for repositories.
 * Each repository will have a configuration with each of the names.
 */
export var RateLimitName;
(function (RateLimitName) {
    /**
     * Rate limit configurations that pertain to agent scan rates
     */
    RateLimitName["ScanningRequests"] = "Scanning requests";
    /**
     * Agent upload rate limit configuration name
     */
    RateLimitName["UploadRequests"] = "Upload requests";
})(RateLimitName || (RateLimitName = {}));
